var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyLocationPicta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 68.5",
    style: {
      enableBackground: "new 0 0 60 68.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#BA3A39;}\r\n\t.st1{fill:#BA3A39;stroke:#FFFFFF;stroke-width:2;stroke-linejoin:round;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.5,68.5V45.4H7.4L30.5,68.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.5,45.4v23.1l23.1-23.1H30.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 30,
    cy: 30,
    r: 29
  }), /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2_00000178910494646182438900000008147487549321707651_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.7,38.4l1.4-3.3l3.4,3.4l-1.1,2.3c-0.1,0.2-0.3,0.4-0.4,0.6l-4.3,4.1c-0.8,0.8-2.2,0.8-3,0 c-0.8-0.8-0.8-2.2,0-3l3.5-3.5C23.5,38.9,23.6,38.7,23.7,38.4L23.7,38.4L23.7,38.4z M25.4,26.4l1.8-0.7l-1.2,5.5 c-0.1,0.3,0,0.7,0.2,0.9v0l3.6,4v0v0l2.2,2.9c0.2,0.2,0.3,0.5,0.3,0.7l1.2,4.8c0.3,1.1,1.5,1.8,2.6,1.5c1.1-0.3,1.8-1.5,1.5-2.6 l-1.4-5.7c-0.1-0.3-0.2-0.6-0.4-0.8l-3.6-4.5l1.1-4.4l0.6,1.7c0.1,0.4,0.4,0.7,0.7,0.9l2.3,1.7c0.9,0.7,2.3,0.5,3-0.4 c0.7-0.9,0.5-2.3-0.4-3l-1.7-1.3c-0.3-0.2-0.5-0.5-0.7-0.9l-1.4-3.5c-0.2-0.5-0.5-0.8-0.9-1l0,0c0,0-1.7-1.2-3-1.5 c-1.3-0.3-3.4-0.1-3.6-0.1c-0.3,0-0.5,0-0.8,0.1l-4.8,1.9c-0.1,0-0.2,0.1-0.3,0.2L20.1,26c-0.7,0.9-0.5,2.3,0.4,3 c0.9,0.7,2.3,0.5,3-0.4l1.4-1.9C25,26.5,25.2,26.4,25.4,26.4L25.4,26.4L25.4,26.4z M32.4,19.6c2.1,0,3.7-1.7,3.7-3.7 s-1.7-3.7-3.7-3.7s-3.7,1.7-3.7,3.7S30.4,19.6,32.4,19.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyLocationPicta);
export default __webpack_public_path__ + "static/media/my-location-picta.f74d9bed911bd533ce63aee9f8e8df69.svg";
export { ForwardRef as ReactComponent };